(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'smooth' });
        }
      },
      { once: true }
    );
  }
  
  // Add to cart functionality
  document.addEventListener('click', function(e) {
    if (e.target.classList.contains('azaro-add-to-cart-btn')) {
      e.preventDefault();
      const variantId = e.target.dataset.variantId;
      const quantity = 1;
      
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: quantity
        })
      })
      .then(response => response.json())
      .then(data => {
        // Show success message
        e.target.textContent = '✓ Added to Cart';
        e.target.style.background = '#6B8E7F';
        e.target.style.borderColor = '#6B8E7F';
        
        // Reset button after 2 seconds
        setTimeout(() => {
          e.target.textContent = 'Add to Cart';
          e.target.style.background = '';
          e.target.style.borderColor = '';
        }, 2000);
        
        // Open cart drawer if available
        if (window.cartDrawer) {
          window.cartDrawer.open();
        }
      })
      .catch(error => console.error('Error:', error));
    }
  });

  } catch(e) { console.error(e); }
})();
})();
